(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
class TabbedProductCarousel extends HTMLElement {
  connectedCallback() {
    this._tabs = Array.from(this.querySelectorAll('.tpc__tab'));
    this._panels = Array.from(this.querySelectorAll('.tpc__panel'));

    this._tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this._activate(index));
      tab.addEventListener('keydown', (e) => this._handleKey(e, index));
    });

    this.addEventListener('shopify:block:select', (e) => {
      const tab = e.target.closest('.tpc__tab');
      if (!tab) return;
      const index = this._tabs.indexOf(tab);
      if (index !== -1) this._activate(index);
    });
  }

  _activate(index) {
    this._tabs.forEach((tab, i) => {
      const on = i === index;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', String(on));
      tab.setAttribute('tabindex', on ? '0' : '-1');
    });

    this._panels.forEach((panel, i) => {
      const on = i === index;
      panel.classList.toggle('is-active', on);
      if (on) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  _handleKey(e, current) {
    const count = this._tabs.length;
    let next = current;

    if (e.key === 'ArrowRight') next = (current + 1) % count;
    else if (e.key === 'ArrowLeft') next = (current - 1 + count) % count;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = count - 1;
    else return;

    e.preventDefault();
    this._activate(next);
    this._tabs[next].focus();
  }
}

if (!customElements.get('tabbed-product-carousel')) {
  customElements.define('tabbed-product-carousel', TabbedProductCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner-carousel"] && !Shopify.designMode) return;
  try {
    
  class HeroBannerCarousel extends HTMLElement {
    constructor() {
      super();
      this.track       = this.querySelector('.hero-banner-carousel__track');
      this.slides      = this.querySelectorAll('.hero-banner-carousel__slide');
      this.dots        = this.querySelectorAll('.hero-banner-carousel__dot');
      this.prevBtn     = this.querySelector('.hero-banner-carousel__arrow--prev');
      this.nextBtn     = this.querySelector('.hero-banner-carousel__arrow--next');
      this.liveRegion  = this.querySelector('.hero-banner-carousel__live-region');
      this.current     = 0;
      this.total       = this.slides.length;
      this.autoplay    = this.dataset.autoplay === 'true';
      this.speed       = parseInt(this.dataset.speed, 10) || 5000;
      this.timer       = null;
      this.touchStartX = 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    connectedCallback() {
      if (this.total <= 1) return;

      this.prevBtn?.addEventListener('click', () => this.go(this.current - 1));
      this.nextBtn?.addEventListener('click', () => this.go(this.current + 1));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.go(parseInt(dot.dataset.index, 10)));
      });

      this.addEventListener('touchstart', (e) => {
        this.touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.addEventListener('touchend', (e) => {
        const diff = this.touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 50) {
          this.go(diff > 0 ? this.current + 1 : this.current - 1);
        }
      }, { passive: true });

      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft')  { e.preventDefault(); this.go(this.current - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.current + 1); }
      });

      if (this.autoplay && !this.reducedMotion) {
        this.startAutoplay();
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin',    () => this.stopAutoplay());
        this.addEventListener('focusout',   () => this.startAutoplay());
      }

      document.addEventListener('shopify:block:select', (e) => {
        const slide = this.querySelector(`#${e.detail.blockId}`);
        if (!slide) return;
        const index = [...this.slides].indexOf(slide);
        if (index !== -1) {
          this.stopAutoplay();
          this.go(index);
        }
      });
    }

    go(index) {
      const prev = this.current;
      this.current = (index + this.total) % this.total;

      this.track.style.transform = `translateX(-${this.current * 100}%)`;

      this.slides[prev].classList.remove('is-active');
      this.slides[this.current].classList.add('is-active');

      if (this.dots[prev]) {
        this.dots[prev].classList.remove('is-active');
        this.dots[prev].setAttribute('aria-selected', 'false');
      }
      if (this.dots[this.current]) {
        this.dots[this.current].classList.add('is-active');
        this.dots[this.current].setAttribute('aria-selected', 'true');
      }

      if (this.liveRegion) {
        this.liveRegion.textContent = `${this.current + 1} / ${this.total}`;
      }
    }

    startAutoplay() {
      this.stopAutoplay();
      this.timer = setInterval(() => this.go(this.current + 1), this.speed);
    }

    stopAutoplay() {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  if (!customElements.get('hero-banner-carousel')) {
    customElements.define('hero-banner-carousel', HeroBannerCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olcu-secenekleri"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-option-group]').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var item = e.target.closest('[data-option-item]');
      if (!item) return;
      group.querySelectorAll('[data-option-item]').forEach(function (i) {
        i.classList.remove('is-selected');
        i.setAttribute('aria-pressed', 'false');
      });
      item.classList.add('is-selected');
      item.setAttribute('aria-pressed', 'true');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-product-carousel"] && !Shopify.designMode) return;
  try {
    

class TabbedProductCarousel extends HTMLElement {
  connectedCallback() {
    this._tabs   = [...this.querySelectorAll('.tpc__tab')];
    this._panels = [...this.querySelectorAll('.tpc__panel')];

    this._tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this._activate(i));
    });

    this._panels.forEach(panel => {
      const track = panel.querySelector('.tpc__track');
      if (!track) return;

      panel.querySelector('.tpc__arrow--prev')
        ?.addEventListener('click', () => track.scrollBy({ left: -260, behavior: 'smooth' }));
      panel.querySelector('.tpc__arrow--next')
        ?.addEventListener('click', () => track.scrollBy({ left: 260, behavior: 'smooth' }));

      this._initDots(panel, track);
    });
  }

  _activate(index) {
    this._tabs.forEach((t, i) => {
      t.classList.toggle('is-active', i === index);
      t.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });

    this._panels.forEach((p, i) => {
      const active = i === index;
      p.classList.toggle('is-active', active);
      if (active) {
        const track = p.querySelector('.tpc__track');
        if (track) track.scrollLeft = 0;
        p.querySelectorAll('.tpc__dot').forEach((d, di) => d.classList.toggle('is-active', di === 0));
      }
    });
  }

  _initDots(panel, track) {
    const dots  = [...panel.querySelectorAll('.tpc__dot')];
    const cards = [...panel.querySelectorAll('.tpc__card')];
    if (!dots.length || !cards.length) return;

    const io = new IntersectionObserver(
      entries => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            const i = cards.indexOf(e.target);
            if (i === -1) return;
            dots.forEach((d, di) => d.classList.toggle('is-active', di === i));
          }
        });
      },
      { root: track, threshold: 0.6 }
    );

    cards.forEach(c => io.observe(c));
  }
}

if (!customElements.get('tabbed-product-carousel')) {
  customElements.define('tabbed-product-carousel', TabbedProductCarousel);
}


  } catch(e) { console.error(e); }
})();
})();
